import httpClient from "./httpClient";

const base = "/class-routine-details";

export function saveClassRoutineDetails(payload) {
  return httpClient.post(base, payload).then((res) => res.data);
}

export function listClassRoutineDetails(classConfigId, groupId) {
  return httpClient.get(base, { params: { classConfigId, groupId } }).then((res) => res.data.data);
}

export function updateClassRoutineDetails(payload) {
  return httpClient.put(base, payload).then((res) => res.data);
}
